import React from 'react';
import Layout from '../../../layout/Layout/Layout';
import Header from '../Header/Header';
import Content from '../../../layout/Content/Content';
import Navigation from '../Navigation/Navigation';
import Sidebar from '../Sidebar/Sidebar';
import SEO from '../../../seo/SEO/SEO';
import * as styles from './page.module.scss';
import { classNames } from '../../../../utils';


export default function Page( { heading, desc, children, pageContext, isDocument } ) {
  const Wrapper = isDocument ? 'article' : 'section';

  return (
    <Layout>
      <SEO title={ heading } description={ desc } isArticle={ true }/>

      <Wrapper>
        <Header heading={ heading } desc={ desc } />

        <div className={ styles.pageBody }>
          <Content innerClassName={ styles.pageBodyInner }>
            <div className={ classNames( styles.pageContent, isDocument ? styles.pageContentDocument : '' ) }>
              { children }

              { pageContext && (
                <div className={ styles.pageFooter }>
                  <Navigation
                    prev={ pageContext.prev }
                    next={ pageContext.next }
                  />
                </div>
              ) }
            </div>

            <Sidebar className={ classNames( styles.pageSidebar, 'js-scroll' ) }/>
          </Content>
        </div>
      </Wrapper>
    </Layout>
  );
}